import React, { useCallback } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { useDebouncedCallback } from 'use-debounce'

import TagSelect from './TagSelect'
import {
  clearConstituentTags,
  loadConstituentTags,
  paginateConstituentTags,
} from '../../../redux/features/constituentsSlice'
import { addLeadingZeroToDistrict } from '../../../utils'

const ConstituentTagSelect = ({ district, ...props }) => {
  const dispatch = useDispatch()
  const isLoading = useSelector(state => state.constituents.tags_loading)
  const user = useSelector(state => state.auth.user)

  const filters = useSelector(state => state.directory.filters) || []

  const selectedDistrictFilter = filters.district__in

  const districtValue = user.is_admin
    ? district ?? undefined
    : addLeadingZeroToDistrict(user.district)

  const filterParams = {
    district__in: districtValue ? [districtValue] : selectedDistrictFilter,
    label: '',
  }

  const loadOptions = searchTerm => {
    dispatch(clearConstituentTags())
    dispatch(loadConstituentTags({ ...filterParams, label: searchTerm }))
  }

  const debouncedHandleChange = useDebouncedCallback(e => {
    loadOptions(e.target.value)
  }, 500)

  const loadMoreTags = useCallback(() => {
    dispatch(paginateConstituentTags())
  }, [])

  const tagOptions = useSelector(state => state.constituents.tag_options) || []

  return (
    <TagSelect
      district={district}
      onSearch={debouncedHandleChange}
      tagOptions={tagOptions}
      loadOptions={loadOptions}
      loadMoreOptions={loadMoreTags}
      isLoading={isLoading}
      {...props}
    />
  )
}

export default ConstituentTagSelect
